import React from 'react'; 

const ResultsLimited = () => ( 
  <div className="alert alert-warning text-center">
    Too many records found. Results are limited. Try again using more specific search terms.
  </div>
);

export default ResultsLimited;



// WEBPACK FOOTER //
// ./src/features/admin/audit/ResultsLimited.jsx